import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';
import { Question } from '../../interfaces/questionInterface';

@Component({
    selector: 'app-question-overview',
    imports: [NgIconComponent],
    templateUrl: './question-overview.component.html',
    styleUrl: './question-overview.component.scss'
})
export class QuestionOverviewComponent implements OnInit {
  public currentOverviewQuestions: Question[] = [];
  public hasOverviewAllQuestions: boolean = true;

  @Input() questions: Question[] = [];
  @Input() flaggedQuestions: string[] = [];
  @Input() answers: Map<string, { elapsedSeconds: number, answers: string[] }> | undefined;

  @Output() toggleModal = new EventEmitter<void>();
  @Output() questionFlagged = new EventEmitter<{id: string, flagged: boolean}>();
  @Output() questionSelected = new EventEmitter<number>();

  ngOnInit(): void {
    this.currentOverviewQuestions = this.questions;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["flaggedQuestions"]) {
      this.setCurrentQuestions();
    }
  }

  public changeCurrentOverviewQuestionsTab() {
    this.hasOverviewAllQuestions = !this.hasOverviewAllQuestions;
    this.setCurrentQuestions();
  }

  public handleQuestionFlagged(e: Event, id: string, flagged: boolean) {
    this.questionFlagged.emit({id, flagged})
    e.preventDefault();
  }

  public setCurrentQuestions() {
    if (!this.hasOverviewAllQuestions) {
      this.currentOverviewQuestions = this.questions.filter(question => this.flaggedQuestions.includes(question.id));
    } else if (this.hasOverviewAllQuestions) {
      this.currentOverviewQuestions = this.questions;
    };
  }

  public handleQuestionSelected(index: number) {
    this.toggleModal.emit();
    this.questionSelected.emit(index);
  }

  public checkIfAnswered(questionId: string) {
    return this.answers?.get(questionId)?.answers?.length ? true : false;
  }

  public checkIfDisabled(index: number) {
    if(this.answers) {
      const actualAnswers = Array.from(this.answers.values()).filter((answer) => answer.answers.length > 0);
      return index > actualAnswers.length;
    } 
    return true;
  }

  public reset() {
    this.hasOverviewAllQuestions = true;
    this.setCurrentQuestions();
  }

}
